import { Skeleton, useColorModeValue } from '@chakra-ui/react';

function EventHeaderSkeleton({ startColor, endColor }) {
  return (
    <div className="flex flex-row items-center gap-[8px]">
      <Skeleton
        flexShrink={0}
        width="53px"
        height="42px"
        borderRadius="10px"
        startColor={startColor}
        endColor={endColor}
      />
      <div className="flex flex-col gap-[4px]">
        <Skeleton
          width="120px"
          height="18px"
          borderRadius="4px"
          startColor={startColor}
          endColor={endColor}
        />
        <Skeleton
          width="80px"
          height="14px"
          borderRadius="4px"
          startColor={startColor}
          endColor={endColor}
        />
      </div>
    </div>
  );
}

function CollectionSection({ startColor, endColor, count, headerPaddingTop = '20px' }) {
  return (
    <div>
      <div style={{ paddingTop: headerPaddingTop, paddingBottom: '9px' }}>
        <EventHeaderSkeleton startColor={startColor} endColor={endColor} />
      </div>
      <div className="grid grid-cols-[repeat(auto-fill,75px)] gap-[8px]">
        {Array.from({ length: count }, (_, i) => `col-${i}`).map((key) => (
          <Skeleton
            key={key}
            width="75px"
            height="118px"
            borderRadius="8px"
            startColor={startColor}
            endColor={endColor}
          />
        ))}
      </div>
    </div>
  );
}

function EditorSection({ startColor, endColor, count, headerMarginTop = '12px' }) {
  return (
    <div>
      <div style={{ marginTop: headerMarginTop, marginBottom: '9px' }}>
        <EventHeaderSkeleton startColor={startColor} endColor={endColor} />
      </div>
      <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-6 gap-[8px]">
        {Array.from({ length: count }, (_, i) => `col-${i}`).map((key) => (
          <div key={key} className="aspect-[75/118] w-full">
            <Skeleton
              width="100%"
              height="100%"
              borderRadius="8px"
              startColor={startColor}
              endColor={endColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function LegacySection({ startColor, endColor, count, headerPaddingTop = '20px' }) {
  return (
    <div>
      <div style={{ paddingTop: headerPaddingTop, paddingBottom: '9px' }}>
        <EventHeaderSkeleton startColor={startColor} endColor={endColor} />
      </div>
      <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-6 gap-[4px]">
        {Array.from({ length: count }, (_, i) => `col-${i}`).map((key) => (
          <div key={key} className="aspect-[55/87] w-full">
            <Skeleton
              width="100%"
              height="100%"
              borderRadius="8px"
              startColor={startColor}
              endColor={endColor}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function EmptyPhotoCardEventSkeletonV2(props) {
  const variant = props.variant ?? 'collection';
  const startColor = useColorModeValue('separator.light.1', 'separator.dark.1');
  const endColor = useColorModeValue('separator.light.2', 'separator.dark.2');

  if (variant === 'editorGrid') {
    return (
      <div className="w-full flex flex-col">
        <EditorSection startColor={startColor} endColor={endColor} count={8} headerMarginTop="0" />
        <EditorSection startColor={startColor} endColor={endColor} count={4} />
      </div>
    );
  }

  if (variant === 'legacyReported') {
    return (
      <div className="w-full flex flex-col">
        <LegacySection startColor={startColor} endColor={endColor} count={4} />
        <LegacySection
          startColor={startColor}
          endColor={endColor}
          count={3}
          headerPaddingTop="24px"
        />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col">
      <CollectionSection startColor={startColor} endColor={endColor} count={8} />
      <CollectionSection
        startColor={startColor}
        endColor={endColor}
        count={4}
        headerPaddingTop="24px"
      />
    </div>
  );
}
